module.exports = __webpack_public_path__ + "img/gray_light_marker2.f61d4431.svg";